import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AnalysisGraphQL} from './AnalysisTypes';

export default function isAnalysisSucceeded(analysis: Pick<AnalysisGraphQL, 'execution'>): boolean {
  return analysis.execution.steps.every(
    (step) =>
      step.statusCode === PipelineStepStatusCode.SUCCEEDED ||
      step.statusCode === PipelineStepStatusCode.HALTED
  );
}
